"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHolderBlockReason = exports.CardRequestOrigination = exports.CardDuplicateReplacementReason = exports.CardBlockReason = exports.CardType = exports.CardStatus = exports.CardReplacementStatus = exports.CardRenewalStatus = exports.CardTransactionType = exports.CardPeriodType = exports.CardClass = void 0;
var CardClass;
(function (CardClass) {
    CardClass["VISA_CLASSIC"] = "VISA_CLASSIC";
    CardClass["VISA_GOLD"] = "VISA_GOLD";
})(CardClass || (exports.CardClass = CardClass = {}));
var CardPeriodType;
(function (CardPeriodType) {
    CardPeriodType["DAY"] = "DAY";
    CardPeriodType["MAX_MONTHLY"] = "MAX_MONTHLY";
    CardPeriodType["MONTH"] = "MONTH";
    CardPeriodType["TRANSACTION"] = "TRANSACTION";
})(CardPeriodType || (exports.CardPeriodType = CardPeriodType = {}));
var CardTransactionType;
(function (CardTransactionType) {
    CardTransactionType["CASH"] = "CASH";
    CardTransactionType["CONTACTLESS"] = "CONTACTLESS";
    CardTransactionType["GLOBAL"] = "GLOBAL";
    CardTransactionType["ONLINE"] = "ONLINE";
    CardTransactionType["REGULAR"] = "REGULAR";
})(CardTransactionType || (exports.CardTransactionType = CardTransactionType = {}));
var CardRenewalStatus;
(function (CardRenewalStatus) {
    CardRenewalStatus["CANCELLED"] = "CANCELLED";
    CardRenewalStatus["CANCELLED_BY_USER"] = "CANCELLED_BY_USER";
    CardRenewalStatus["DONE"] = "DONE";
    CardRenewalStatus["ELIGIBLE"] = "ELIGIBLE";
    CardRenewalStatus["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
})(CardRenewalStatus || (exports.CardRenewalStatus = CardRenewalStatus = {}));
var CardReplacementStatus;
(function (CardReplacementStatus) {
    CardReplacementStatus["IN_PROGRESS"] = "IN_PROGRESS";
    CardReplacementStatus["DONE"] = "DONE";
})(CardReplacementStatus || (exports.CardReplacementStatus = CardReplacementStatus = {}));
var CardStatus;
(function (CardStatus) {
    CardStatus["ACTIVE"] = "ACTIVE";
    CardStatus["BLOCKED"] = "BLOCKED";
    CardStatus["CLOSED"] = "CLOSED";
    CardStatus["CREATED"] = "CREATED";
    CardStatus["NEW"] = "NEW";
})(CardStatus || (exports.CardStatus = CardStatus = {}));
var CardType;
(function (CardType) {
    CardType["PHYSICAL_AND_VIRTUAL"] = "PHYSICAL_AND_VIRTUAL";
    CardType["VIRTUAL"] = "VIRTUAL";
})(CardType || (exports.CardType = CardType = {}));
var CardBlockReason;
(function (CardBlockReason) {
    CardBlockReason["LostOrStolen"] = "LOST_STOLEN";
    CardBlockReason["Fraud"] = "FRAUD";
    CardBlockReason["Inactive"] = "INACTIVE";
})(CardBlockReason || (exports.CardBlockReason = CardBlockReason = {}));
var CardDuplicateReplacementReason;
(function (CardDuplicateReplacementReason) {
    CardDuplicateReplacementReason["DeliveryError"] = "DELIVERY_ERROR";
    CardDuplicateReplacementReason["NotSuitable"] = "NOT_SUITABLE";
})(CardDuplicateReplacementReason || (exports.CardDuplicateReplacementReason = CardDuplicateReplacementReason = {}));
var CardRequestOrigination;
(function (CardRequestOrigination) {
    CardRequestOrigination["SelfService"] = "SELF_SERVICE";
})(CardRequestOrigination || (exports.CardRequestOrigination = CardRequestOrigination = {}));
var CardHolderBlockReason;
(function (CardHolderBlockReason) {
    CardHolderBlockReason["Debt"] = "DEBT";
    CardHolderBlockReason["SuspectedFraud"] = "SUSPECTED_FRAUD";
    CardHolderBlockReason["CustomerProceeding"] = "CUSTOMER_PROCEEDING";
    CardHolderBlockReason["SeizureProceeding"] = "SEIZURE_PROCEEDING";
    CardHolderBlockReason["BailiffProceeding"] = "BAILIFF_PROCEEDING";
    CardHolderBlockReason["BankruptcyCase"] = "BANKRUPTCY_CASE";
    CardHolderBlockReason["CriminalCase"] = "CRIMINAL_CASE";
    CardHolderBlockReason["DeathCase"] = "DEATH_CASE";
})(CardHolderBlockReason || (exports.CardHolderBlockReason = CardHolderBlockReason = {}));
